import { createFileRoute } from '@tanstack/react-router'
import { AlertsPage } from 'pages/alerts/Alerts'
import { z } from 'zod'

const parseParams = z.object({
  siteID: z.string(),
})

const searchSchema = z.object({
  page: z.number().optional().default(0),
  pageSize: z.number().optional().default(25),
  selectedAlertId: z.string().optional(),
  // Table filter columns
  'data.priority': z.number().optional(),
  'data.timestamp': z
    .tuple([z.string().nullable(), z.string().nullable()])
    .optional(),
  'data.acknowledged': z.array(z.string()).optional(),
  'data.status': z.string().optional(),
  'data.area': z.string().optional(),
  'data.name': z.string().optional(),
  'data.description': z.string().optional(),
  'data.alerted_value': z.number().optional(),
  'data.setpoint': z.number().optional(),
  'data.unit': z.string().optional(),
})

export const Route = createFileRoute('/alerts/{-$siteID}/')({
  component: AlertsPage,
  params: {
    parse: parseParams.parse,
  },
  validateSearch: searchSchema,
  staticData: {
    title: 'Alerts',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
